import { render, staticRenderFns } from "./SupplierEmail.vue?vue&type=template&id=1afe9f65&scoped=true"
import script from "./SupplierEmail.vue?vue&type=script&lang=js"
export * from "./SupplierEmail.vue?vue&type=script&lang=js"
import style0 from "./SupplierEmail.vue?vue&type=style&index=0&id=1afe9f65&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe9f65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afe9f65')) {
      api.createRecord('1afe9f65', component.options)
    } else {
      api.reload('1afe9f65', component.options)
    }
    module.hot.accept("./SupplierEmail.vue?vue&type=template&id=1afe9f65&scoped=true", function () {
      api.rerender('1afe9f65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/visitPlan/SupplierEmail.vue"
export default component.exports